export default class ImageSelect2
{

   private readonly instance: JQuery<Element>;

   constructor(element :Element) {
      // @ts-ignore
      this.instance = $(element).select2({
         templateSelection: this.formatState,
         templateResult: this.formatState,
         minimumResultsForSearch: Infinity
      });
   }

   getInstance() :JQuery<Element>{
      return this.instance;
   }

   formatState(state :any) {
      if (!state.id)
         return state.text;

      const option = $(state.element);

      if(!option.attr('data-flag-icon'))
         return state.text;

      return $(
         `<span><img src="${option.attr('data-flag-icon')}" class="img-flag" width="20" height="15" alt="${state.text}"/> ${state.text}</span>`
      );
   }
}